export default "__VITE_ASSET__bb29e388__"